__turbopack_context__.v({
  "aside": "gift-set-builder-module-scss-module__pk4rEG__aside",
  "aside-body": "gift-set-builder-module-scss-module__pk4rEG__aside-body",
  "aside-title": "gift-set-builder-module-scss-module__pk4rEG__aside-title",
  "check": "gift-set-builder-module-scss-module__pk4rEG__check",
  "cover": "gift-set-builder-module-scss-module__pk4rEG__cover",
  "cta": "gift-set-builder-module-scss-module__pk4rEG__cta",
  "eyebrow": "gift-set-builder-module-scss-module__pk4rEG__eyebrow",
  "foot": "gift-set-builder-module-scss-module__pk4rEG__foot",
  "gift": "gift-set-builder-module-scss-module__pk4rEG__gift",
  "gift-item": "gift-set-builder-module-scss-module__pk4rEG__gift-item",
  "gift-name": "gift-set-builder-module-scss-module__pk4rEG__gift-name",
  "gift-note": "gift-set-builder-module-scss-module__pk4rEG__gift-note",
  "gift-picture": "gift-set-builder-module-scss-module__pk4rEG__gift-picture",
  "gifts-head": "gift-set-builder-module-scss-module__pk4rEG__gifts-head",
  "grid": "gift-set-builder-module-scss-module__pk4rEG__grid",
  "h2": "gift-set-builder-module-scss-module__pk4rEG__h2",
  "hero": "gift-set-builder-module-scss-module__pk4rEG__hero",
  "hint": "gift-set-builder-module-scss-module__pk4rEG__hint",
  "image": "gift-set-builder-module-scss-module__pk4rEG__image",
  "intro": "gift-set-builder-module-scss-module__pk4rEG__intro",
  "lead": "gift-set-builder-module-scss-module__pk4rEG__lead",
  "main": "gift-set-builder-module-scss-module__pk4rEG__main",
  "message": "gift-set-builder-module-scss-module__pk4rEG__message",
  "note": "gift-set-builder-module-scss-module__pk4rEG__note",
  "old": "gift-set-builder-module-scss-module__pk4rEG__old",
  "option": "gift-set-builder-module-scss-module__pk4rEG__option",
  "option-name": "gift-set-builder-module-scss-module__pk4rEG__option-name",
  "option-text": "gift-set-builder-module-scss-module__pk4rEG__option-text",
  "picture": "gift-set-builder-module-scss-module__pk4rEG__picture",
  "price": "gift-set-builder-module-scss-module__pk4rEG__price",
  "price-row": "gift-set-builder-module-scss-module__pk4rEG__price-row",
  "prices": "gift-set-builder-module-scss-module__pk4rEG__prices",
  "reset": "gift-set-builder-module-scss-module__pk4rEG__reset",
  "root": "gift-set-builder-module-scss-module__pk4rEG__root",
  "row": "gift-set-builder-module-scss-module__pk4rEG__row",
  "row-picture": "gift-set-builder-module-scss-module__pk4rEG__row-picture",
  "rows": "gift-set-builder-module-scss-module__pk4rEG__rows",
  "section": "gift-set-builder-module-scss-module__pk4rEG__section",
  "status": "gift-set-builder-module-scss-module__pk4rEG__status",
  "title": "gift-set-builder-module-scss-module__pk4rEG__title",
});
